const mobileMenuBreakpoint = 1200;
const $win = $(window);
const $body = $('body');

const $header = $('.site-header');
const $headerMenu = $header.find('#menu-main-menu');
const $headerNav = $header.find('.wp-classic-menu-block');

function navigateMobileSubMenu(level, $subMenu) {
    console.log('this should be working')
    $subMenu = $subMenu || null;
    console.log($subMenu)
    if($subMenu) {
        $headerMenu.find('.sub-menu[data-level=' + level + ']').removeClass('active');
        $subMenu.addClass('active');
    }
    console.log($headerMenu)
    $headerMenu.css('transform', 'translate(' + (-100 * level) + '%)');
    $headerNav.attr('data-currentlevel', level);
}

$('.site-header .sub-menu-back').click(function () {
    const level = $(this).attr('data-backlevel');
    navigateMobileSubMenu(level);
});

$('.site-header .menu-item-has-children').each(function (){
    const $self = $(this);
    const $link = $self.find('> a');
    const $subMenu = $self.find('> .sub-menu');
    const $subMenuBack = $subMenu.find('> .sub-menu__back');

    const linkHref = $link.attr('href');

    if(linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
        const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
        $link.clone().appendTo($menuItemDuplicate);
        $subMenuBack.after($menuItemDuplicate);
    }

    $link.click(function (event) {
        console.log('CLICKED');
        if($win.width() <= mobileMenuBreakpoint) {
            console.log('HEY Prevent');
            event.preventDefault();
            navigateMobileSubMenu($subMenu.attr('data-level'), $subMenu);
        }
    });
});

$('.mobile-close, .mobile-menu-toggle').click(function () {
    $headerNav.toggleClass('open');
    $body.toggleClass('open');
    $('html').toggleClass('open');
    $(this).toggleClass('is-active');
});

// Add header height as css var.
function setMenuHeightVar() {
    $body.css('--header-height', $('header').innerHeight() + 'px');
}

document.addEventListener('DOMContentLoaded', setMenuHeightVar);

// Do this on resize
window.addEventListener('resize', event => {
    setMenuHeightVar();
});
